// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rzC72xV7{align-items:center;background-color:var(--color-card-bg);display:flex;gap:1.5rem;margin-left:calc(var(--content-padding-x)*-1);margin-right:calc(var(--content-padding-x)*-1);padding:1rem var(--content-padding-x)}@media(max-width:667.98px){.rzC72xV7{align-items:flex-start;flex-direction:column;gap:1rem}}.cdBbHlfL{flex-shrink:0;height:2.5rem;-o-object-fit:contain;object-fit:contain;width:2.5rem}.YYc\\+jLzl{flex-grow:1;overflow:hidden}.J14\\+R8j2{font-size:1rem;font-weight:600;line-height:1.5}.Z3V1ueCt{font-size:.88rem;line-height:1.43}.MchIpcDS{flex-shrink:0}@media(max-width:667.98px){.MchIpcDS{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"banner": "rzC72xV7",
	"logo": "cdBbHlfL",
	"meta": "YYc+jLzl",
	"title": "J14+R8j2",
	"text": "Z3V1ueCt",
	"btn": "MchIpcDS"
};
module.exports = ___CSS_LOADER_EXPORT___;
